export default "__VITE_ASSET__M5aDvW3y__"